import { DocList } from "../DocList";
import { ContactEmail } from "./ContactEmail";

/** The person's rights, how to use them, and how the notice changes. */
export function PrivacyRights({ contact }: { contact: string }): React.JSX.Element {
  const mail = <ContactEmail contact={contact} />;
  return (
    <>
      <h3>Your rights</h3>
      <p>Under Chilean Law 21.719 you can ask to:</p>
      <DocList>
        <li>access your personal data;</li>
        <li>correct it;</li>
        <li>delete it;</li>
        <li>object to a use of it;</li>
        <li>receive a portable copy of it;</li>
        <li>temporarily block its use.</li>
      </DocList>
      <p>
        If you live in the United States (for example in California), you also have the right to know what personal data we hold
        about you, to delete it and to correct it, and you won&apos;t be treated differently for using any of these rights.
      </p>
      <p>
        To use your rights, go to My account, where you can download your data and make a request, or write to {mail}. We answer
        within 30 calendar days. If we need more time, we can extend that once, by another 30 days, and we&apos;ll tell you why. If
        you aren&apos;t satisfied with our answer, you can complain to the Agencia de Protección de Datos Personales (Chile&apos;s
        personal data protection agency).
      </p>

      <h3>Automated decisions</h3>
      <p>No decision about you is made automatically, without a person involved.</p>

      <h3>Children</h3>
      <p>The suite is for work. It is not meant for minors, and we don&apos;t knowingly handle their data.</p>

      <h3>Changes to this notice</h3>
      <p>
        When this notice changes, the new version is shown the next time you sign in, and you need to accept it before you continue.
      </p>
    </>
  );
}
